module.exports = __webpack_public_path__ + "static/img/data1.7def98f1.png";